<template>
    <router-view/>
</template>

<script>
export default {
  data() {
      return {};
    }    
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue